import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Listbox } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  PlusSmIcon as PlusSmIconSolid,
  MinusIcon,
  PlusSmIcon as PlusSmIconOutline,
  MinusSmIcon as MinusSmIconOutline,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import Configunitmodal from "./Configunitmodal";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class ItemModalcreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      type_id: "",
      name: "",
      sku: "",
      unit_id: "",
      hsn_code: "",
      tax_preference_id: "",
      dimension_length: "",
      dimension_width: "",
      dimension_height: "",
      Weight: "",
      intra_state_tax_rate_id: "",
      inter_state_tax_rate_id: "",
      salesinformationwant: "",
      purchaseinformationwant: "",
      track_inventory_for_this_item: false,
      inventory_account_id: "",
      opening_stock: "",
      reorder_point: "",
      opening_stock_rate_per_unit: "",
      preferred_vendor_id: "",
      manufacturer_id: "",
      brand_id: "",
      weight_unit_id: "",
      sales_information_want: false,
      sales_selling_price: "",
      sales_account_id: "",
      sales_description: "",
      purchase_information_want: false,
      purchase_cost_price: "",
      purchase_account_id: "",
      purchase_description: "",
      checkedtrackinventory: "",
      preferred_vendor_id_crypt: "",
      success: false,
      redirect: false,
      error_list: [],
      taxPreferencelist: [],
      typeList: [],
      unitList: [],
      weightunitList: [],
      saleAccountlist: [],
      purchaseAccountlist: [],
      Intrastatetaxratelist: [],
      Interstatetaxratelist: [],
      inventoryAccountlist: [],
      manufacturerList: [],
      brandList: [],
      vendorList: [],
      warehouseList: [],
      loader: "",
      overLay: "",
      unitCreate: false,
      item_with_warehouse: [
        { warehouse_id: 0, opening_stock: 0, opening_stock_rate_per_unit: 0 },
      ],
    };
    this.handleInput = this.handleInput.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  handleInputconfig = (e) => {
    if (e) {
      const token = localStorage.getItem("token");
      const res2 = axios
        .get("public/api/item/units", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res2) => {
          this.setState({ unitList: res2.data.units });
        });
    }
    this.setState({ unitCreate: false });
  };

  openunitCreate = (e) => {
    this.setState({ unitCreate: true });
  };
  closeunitCreate = (e) => {
    this.setState({ unitCreate: false });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/item/types", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ typeList: res.data.item_types });
      });

    const res2 = axios
      .get("public/api/item/units", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ unitList: res2.data.units });
      });

    const res3 = axios
      .get("public/api/item/sales-accounts", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ saleAccountlist: res3.data.sales_account_names });
      });

    const res4 = axios
      .get("public/api/item/purchase-accounts", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({
          purchaseAccountlist: res4.data.purchase_account_names,
        });
      });

    const res5 = axios
      .get("public/api/item/tax-preferences", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res5) => {
        this.setState({ taxPreferencelist: res5.data.item_tax_preferences });
      });

    const res6 = axios
      .get("public/api/item/intra-state-tax-rate-types-and-names", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res6) => {
        this.setState({
          Intrastatetaxratelist: res6.data.intra_state_tax_rate_names,
        });
      });

    const res7 = axios
      .get("public/api/item/inter-state-tax-rate-types-and-names", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res7) => {
        this.setState({
          Interstatetaxratelist: res7.data.inter_state_tax_rate_names,
        });
      });

    const res8 = axios
      .get("public/api/item/inventory/account/types/names", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res8) => {
        // console.log(res8.data.inventory_account_types_and_names[0].inventory_account_names);
        this.setState({
          inventoryAccountlist: res8.data.inventory_account_names,
        });
      });
    const res9 = axios
      .get("public/api/manufacture", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res9) => {
        // console.log(res8.data.inventory_account_types_and_names[0].inventory_account_names);
        this.setState({ manufacturerList: res9.data.manufactures });
      });

    const res10 = axios
      .get("public/api/brand", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res10) => {
        // console.log(res8.data.inventory_account_types_and_names[0].inventory_account_names);
        this.setState({ brandList: res10.data.brands });
      });

    const res11 = axios
      .get("public/api/vendors", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res11) => {
        this.setState({ vendorList: res11.data.vendors });
      });

    const res12 = axios
      .get("public/api/item/weight/units", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res12) => {
        this.setState({ weightunitList: res12.data.weight_units });
      });

    const res13 = axios
      .get("public/api/warehouses", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res13) => {
        this.setState({ warehouseList: res13.data.warehouses });
      });

    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        //this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    var token = localStorage.getItem("token");

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangeCheckboxsales = async (e) => {
    this.setState({
      sales_information_want: !this.state.sales_information_want,
    });
  };

  handleChangeCheckboxTrackInv = async (e) => {
    this.setState({
      track_inventory_for_this_item: !this.state.track_inventory_for_this_item,
    });
    console.log(this.state.track_inventory_for_this_item);
  };
  handleChangeCheckboxPurchase = async (e) => {
    this.setState({
      purchase_information_want: !this.state.purchase_information_want,
    });
    console.log(this.state.purchase_information_want);
  };

  addwarehouse = (e) => {
    this.setState({
      item_with_warehouse: this.state.item_with_warehouse.concat([
        {
          warehouse_id: 0,
          opening_stock: 0,
          opening_stock_rate_per_unit: 0,
        },
      ]),
    });
  };

  deletewarehouse = (inventoryindex) => async (e) => {
    this.state.item_with_warehouse = this.state.item_with_warehouse.filter(
      (s, sidx) => inventoryindex !== sidx
    );

    this.setState({
      item_with_warehouse: this.state.item_with_warehouse,
    });
  };

  handleInputinventorywarehouse = (inventoryindex) => (e) => {
    this.state.item_with_warehouse[inventoryindex].warehouse_id =
      e.target.value;
    this.setState({ item_with_warehouse: this.state.item_with_warehouse });
  };
  handleInputinventoryopeningstock = (inventoryindex) => (e) => {
    this.state.item_with_warehouse[inventoryindex].opening_stock =
      e.target.value;
    this.setState({ item_with_warehouse: this.state.item_with_warehouse });
  };

  handleInputinventoryrate = (inventoryindex) => (e) => {
    this.state.item_with_warehouse[inventoryindex].opening_stock_rate_per_unit =
      e.target.value;
    this.setState({ item_with_warehouse: this.state.item_with_warehouse });
  };

  handleInputItem = (e) => {
    this.props.handleInputInvoiceItem(e);
  };

  saveItem = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/item/create", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.handleInputItem(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div className={this.state.overLay} aria-hidden="true" />
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">New Item</h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Type
                                </span>
                              </label>
                              <select
                                id="type_id"
                                name="type_id"
                                onChange={this.handleInput}
                                autoComplete="type_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.typeList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.type_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="email"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Name
                                </span>
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="name"
                                onChange={this.handleInput}
                                autoComplete="name"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="name-error"
                              >
                                {this.state.error_list.name}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="last-name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  SKU
                                </span>
                              </label>
                              <input
                                type="text"
                                name="sku"
                                id="sku"
                                autoComplete="family-name"
                                onChange={this.handleInput}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.sku}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="hsn_code"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Hsncode
                              </label>
                              <input
                                type="text"
                                name="hsn_code"
                                id="hsn_code"
                                autoComplete="family-name"
                                onChange={this.handleInput}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.hsn_code}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-1">
                              <label
                                htmlFor="employee_designation_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Unit
                                </span>
                              </label>
                              <select
                                id="unit_id"
                                name="unit_id"
                                onChange={this.handleInput}
                                autoComplete="unit_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.unitList.map((number) => (
                                  <option value={number.id}>
                                    {number.unit_name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.unit_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-1">
                              <button
                                type="button"
                                onClick={this.openunitCreate}
                                className="mt-5 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                <PlusSmIconOutline
                                  className="h-4 w-4"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="tax_preference_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Tax Preference
                                </span>
                              </label>
                              <select
                                id="tax_preference_id"
                                name="tax_preference_id"
                                onChange={this.handleInput}
                                autoComplete="tax_preference_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.taxPreferencelist.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.tax_preference_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                              <div>
                                <h3 className="text-lg leading-6 font-medium text-gray-900">
                                  Dimensions Details
                                </h3>
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="dimension_length"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Length
                              </label>
                              <input
                                type="text"
                                name="dimension_length"
                                id="dimension_length"
                                onChange={this.handleInput}
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.dimension_length}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="city"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Width
                              </label>
                              <input
                                type="text"
                                name="dimension_width"
                                id="dimension_width"
                                onChange={this.handleInput}
                                autoComplete="dimension_width"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.dimension_width}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="dimension_height"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Height
                              </label>
                              <input
                                type="text"
                                name="dimension_height"
                                onChange={this.handleInput}
                                id="dimension_height"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.dimension_height}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="weight"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Weight
                              </label>
                              <input
                                type="text"
                                name="weight"
                                onChange={this.handleInput}
                                id="weight"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.weight}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="weight_unit_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Weight Unit
                              </label>
                              <select
                                id="weight_unit_id"
                                name="weight_unit_id"
                                onChange={this.handleInput}
                                autoComplete="weight_unit_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.weightunitList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.weight_unit_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                              <label
                                htmlFor="manufacturer_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Manufacturer
                              </label>
                              <select
                                id="manufacturer_id"
                                name="manufacturer_id"
                                onChange={this.handleInput}
                                autoComplete="manufacturer_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.manufacturerList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.manufacturer_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                              <label
                                htmlFor="brand_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Brand
                              </label>
                              <select
                                id="brand_id"
                                name="brand_id"
                                onChange={this.handleInput}
                                autoComplete="brand_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.brandList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.brand_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                              <fieldset className="space-y-5">
                                <legend className="sr-only"></legend>
                                <div className="relative flex items-start">
                                  <div className="flex items-center h-5">
                                    <input
                                      id="sales_information_want"
                                      aria-describedby="comments-description"
                                      name="sales_information_want"
                                      checked={this.state.checked}
                                      onChange={this.handleChangeCheckboxsales}
                                      type="checkbox"
                                      className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                  </div>
                                  <div className="ml-3 text-sm">
                                    <label
                                      htmlFor="sales_information_want"
                                      className="font-medium text-gray-700"
                                    >
                                      Sales Information
                                    </label>
                                  </div>
                                </div>
                              </fieldset>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="sales_selling_price"
                                className="block text-sm font-medium text-gray-700"
                              >
                                {" "}
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Selling Price
                                </span>
                              </label>
                              <input
                                type="text"
                                name="sales_selling_price"
                                onChange={this.handleInput}
                                id="sales_selling_price"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.sales_selling_price}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="city"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Account
                              </label>
                              <select
                                id="sales_account_id"
                                name="sales_account_id"
                                onChange={this.handleInput}
                                autoComplete="sales_account_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.saleAccountlist.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.sales_account_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="sales_description"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Description
                              </label>
                              <div className="mt-1">
                                <textarea
                                  rows={2}
                                  name="sales_description"
                                  onChange={this.handleInput}
                                  id="sales_description"
                                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                              </div>{" "}
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.sales_description}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                              <fieldset className="space-y-5">
                                <legend className="sr-only">
                                  Notifications
                                </legend>
                                <div className="relative flex items-start">
                                  <div className="flex items-center h-5">
                                    <input
                                      id="purchase_information_want"
                                      aria-describedby="purchase_information_want"
                                      name="purchase_information_want"
                                      type="checkbox"
                                      checked={this.state.checked}
                                      onChange={
                                        this.handleChangeCheckboxPurchase
                                      }
                                      className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                  </div>
                                  <div className="ml-3 text-sm">
                                    <label
                                      htmlFor="comments"
                                      className="font-medium text-gray-700"
                                    >
                                      Purchase Information
                                    </label>
                                    <span
                                      id="purchase_information_want"
                                      className="text-gray-500"
                                    >
                                      <span className="sr-only"> </span>
                                    </span>
                                  </div>
                                </div>
                              </fieldset>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                              <label
                                htmlFor="city"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Cost Price
                                </span>
                              </label>
                              <input
                                type="text"
                                name="purchase_cost_price"
                                onChange={this.handleInput}
                                id="purchase_cost_price"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.purchase_cost_price}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="purchase_account_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Account
                              </label>
                              <select
                                id="purchase_account_id"
                                name="purchase_account_id"
                                onChange={this.handleInput}
                                autoComplete="purchase_account_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.purchaseAccountlist.map(
                                  (number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.purchase_account_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="purchase_description"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Description
                              </label>
                              <div className="mt-1">
                                <textarea
                                  rows={2}
                                  name="purchase_description"
                                  onChange={this.handleInput}
                                  id="purchase_description"
                                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                              </div>{" "}
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.purchase_description}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                              <div>
                                <h3 className="text-lg leading-6 font-medium text-gray-900">
                                  Default Tax Rates
                                </h3>
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="city"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Intra State Tax Rate
                              </label>
                              <select
                                id="intra_state_tax_rate_id"
                                name="intra_state_tax_rate_id"
                                onChange={this.handleInput}
                                autoComplete="intra_state_tax_rate_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.Intrastatetaxratelist.map(
                                  (number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.intra_state_tax_rate_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="inter_state_tax_rate_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Inter State Tax Rate
                              </label>
                              <select
                                id="inter_state_tax_rate_id"
                                name="inter_state_tax_rate_id"
                                onChange={this.handleInput}
                                autoComplete="inter_state_tax_rate_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.Interstatetaxratelist.map(
                                  (number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="inter_state_tax_rate_id"
                              >
                                {this.state.error_list.inter_state_tax_rate_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                              <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                <fieldset className="space-y-5">
                                  <legend className="sr-only">
                                    Notifications
                                  </legend>
                                  <div className="relative flex items-start">
                                    <div className="flex items-center h-5">
                                      <input
                                        id="track_inventory_for_this_item"
                                        aria-describedby=""
                                        name="track_inventory_for_this_item"
                                        type="checkbox"
                                        checked={this.state.checked}
                                        onChange={
                                          this.handleChangeCheckboxTrackInv
                                        }
                                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                      />
                                    </div>
                                    <div className="ml-3 text-sm">
                                      <label
                                        htmlFor="track_inventory_for_this_item"
                                        className="font-medium text-gray-700"
                                      >
                                        Track Inventory for this item
                                      </label>
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="inventory_account_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Inventory Account
                                </span>
                              </label>
                              <select
                                id="Type"
                                name="inventory_account_id"
                                onChange={this.handleInput}
                                autoComplete="inventory_account_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.inventoryAccountlist.map(
                                  (number) => (
                                    <option value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.inventory_account_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="reorder_point"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Reorder Point
                              </label>
                              <input
                                type="text"
                                name="reorder_point"
                                onChange={this.handleInput}
                                id="reorder_point"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.reorder_point}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="preferred_vendor_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Preferred Vendor
                              </label>
                              <select
                                id="Type"
                                name="preferred_vendor_id"
                                onChange={this.handleInput}
                                autoComplete=""
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.vendorList.map((number) => (
                                  <option value={number.id}>
                                    {number.vendor_display_name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.preferred_vendor_id}
                              </p>
                            </div>
                          </div>
                          <hr />
                          <div className="mt-8">
                            {this.state.item_with_warehouse.map(
                              (item, index) => (
                                <div className="grid grid-cols-6 gap-6">
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="warehouse_id"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Warehouse
                                    </label>
                                    <select
                                      id="Type"
                                      name="warehouse_id"
                                      onChange={this.handleInputinventorywarehouse(
                                        index
                                      )}
                                      autoComplete=""
                                      value={item.warehouse_id}
                                      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    >
                                      <option value="">------</option>
                                      {this.state.warehouseList.map(
                                        (number) => (
                                          <option value={number.id}>
                                            {number.warehouse_name}
                                          </option>
                                        )
                                      )}
                                    </select>
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.warehouse_id}
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                    <label
                                      htmlFor="opening_stock"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Opening Stock
                                    </label>
                                    <input
                                      type="text"
                                      name="opening_stock"
                                      onChange={this.handleInputinventoryopeningstock(
                                        index
                                      )}
                                      value={item.opening_stock}
                                      id="opening_stock"
                                      autoComplete="address-level2"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.opening_stock}
                                    </p>
                                  </div>

                                  <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="opening_stock_rate_per_unit"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Opening Stock Rate per Unit
                                    </label>
                                    <input
                                      type="text"
                                      name="opening_stock_rate_per_unit"
                                      value={item.opening_stock_rate_per_unit}
                                      onChange={this.handleInputinventoryrate(
                                        index
                                      )}
                                      id="opening_stock_rate_per_unit"
                                      autoComplete="address-level2"
                                      className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    />
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {
                                        this.state.error_list
                                          .opening_stock_rate_per_unit
                                      }
                                    </p>
                                  </div>
                                  <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                    <button
                                      type="button"
                                      className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                      onClick={this.deletewarehouse(index)}
                                    >
                                      <MinusIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </button>
                                  </div>
                                </div>
                              )
                            )}
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                <button
                                  type="button"
                                  className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  onClick={this.addwarehouse}
                                >
                                  <PlusSmIconSolid
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>

        {/** */}
        <Transition.Root show={this.state.unitCreate} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={() => this.closeunitCreate()}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all lg:my-8 lg:max-w-lg lg:w-full lg:p-6">
                    <Configunitmodal
                      handleResultofModal={this.handleInputconfig}
                    />
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/** */}
      </>
    );
  }
}

export default ItemModalcreate;
